import React from 'react';
import { Spinner } from 'components/elements';
import MessageBubble from './MessageBubble';
import type { Message } from './types';
import {
  ChatEmptyState,
  ChatLoadingState,
  ChatLoadingText,
  ChatMessages,
} from './chat.styled';

type MessageListProps = {
  messages: Message[];
  messagesLoading: boolean;
  currentUserId: number;
  isGroup: boolean;
  messagesContainerRef: React.RefObject<HTMLDivElement | null>;
};

const MessageList: React.FC<MessageListProps> = ({
  messages,
  messagesLoading,
  currentUserId,
  isGroup,
  messagesContainerRef,
}) => {
  return (
    <ChatMessages ref={messagesContainerRef}>
      {messagesLoading && messages.length === 0 && (
        <ChatLoadingState>
          <Spinner size="md" />
          <ChatLoadingText>Loading messages...</ChatLoadingText>
        </ChatLoadingState>
      )}
      {messages.map((m) => (
        <MessageBubble
          key={m.id}
          message={m}
          isMine={m.sender_id === currentUserId}
          isGroup={isGroup}
        />
      ))}
      {!messagesLoading && messages.length === 0 && (
        <ChatEmptyState>No messages yet. Say hi!</ChatEmptyState>
      )}
    </ChatMessages>
  );
};

export default MessageList;
